import { ReactNode, useEffect, useState } from "react";
import styles from "./Modal.module.css";
import { DialogContent, DialogOverlay } from "@reach/dialog";
import { VisuallyHidden } from "@reach/visually-hidden";
import { Icon } from "ui-kit";
import { Typography } from "ui-kit/Typography";
import classNames from "classnames";
import { useWebTranslation } from "translations";

export const Modal = ({
  children,
  isOpen,
  onClose,
  title,
  width,
}: {
  children: ReactNode;
  isOpen: boolean;
  onClose: VoidFunction;
  title: string;
  width?: "full" | "small";
}) => {
  const { t } = useWebTranslation();
  const [localIsOpen, setLocalIsOpen] = useState(isOpen);

  useEffect(() => {
    // Trigger a re-render to animate the modal opening
    setLocalIsOpen(isOpen);
  }, [isOpen]);

  return (
    <DialogOverlay
      isOpen={isOpen}
      onDismiss={onClose}
      className={classNames(styles.overlay, localIsOpen && styles.open)}
    >
      <DialogContent
        className={classNames(
          styles.content,
          localIsOpen && styles.open,
          width === "full" && styles.full,
          width === "small" && styles.small
        )}
        aria-label={title}
      >
        <div className={styles.header}>
          <Typography variant="body1" color="grey500">
            <strong>{title}</strong>
          </Typography>

          <button className={classNames(styles.button)} onClick={onClose}>
            <VisuallyHidden>{t("global.close")}</VisuallyHidden>
            <Icon name="close" size="L" ariaHidden />
          </button>
        </div>

        {children}
      </DialogContent>
    </DialogOverlay>
  );
};
